import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ErrorLayer from "../components/ErrorLayer";
import { useAuth } from "../context/AuthContext";

const ErrorPage = () => {
  const { isAuthenticated } = useAuth();
  
  const content = (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="404" />

      {/* ErrorLayer */}
      <ErrorLayer />
    </>
  );

  if (isAuthenticated) {
    return (
      <MasterLayout>
        {content}
      </MasterLayout>
    );
  }

  return (
    <div className="container-fluid py-5 mt-5">
      {content}
    </div>
  );
};

export default ErrorPage;
